import { Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'
import { selectOrg, setOrg } from '../../../redux/orgSlice'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import SchoolEventListener from './listeners/SchoolEventListener'
import SchoolListeners from './listeners/SchoolListeners'
import InitialiseCalendar from './listeners/InitialiseCalendar'
import { Stack, Toolbar } from '@mui/material'
import SchoolHeader from '../../../components/Header/SchoolHeader'
import SchoolModals from '../hooks/useSchoolModals'
import { logger } from '../../../helpers/logger'
import { SCHOOL_LOADING_ERROR_CODES } from '../../../components/LoadingSpinner/loadingErrorCodes'

export const SchoolLayout = () => {
    const { schoolId } = useParams()
    const org = useSelector(selectOrg)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!schoolId || org?.id === schoolId) return
        dispatch(
            setOrg({
                id: schoolId,
                type: 'school',
            })
        )
    }, [dispatch, org, schoolId])

    if (!schoolId || !org || org.id !== schoolId) {
        logger.debug(schoolId, org)
        return (
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                id="school-layout-orgCheck"
                errorCode={SCHOOL_LOADING_ERROR_CODES.SCHOOL_LAYOUT.code}
            />
        )
    }

    return (
        <>
            <InitialiseCalendar />
            <SchoolEventListener schoolUid={org.id} />
            <SchoolListeners schoolUid={org.id} />
            <Stack
                sx={{
                    height: '100%',
                    minHeight: '100vh',
                    overflow: 'hidden',
                }}
            >
                <Suspense fallback={null}>
                    <SchoolModals />
                </Suspense>
                <SchoolHeader schoolUid={org.id} />
                <Toolbar variant="dense" />
                <Stack
                    sx={{
                        flex: 1,
                        minHeight: 'var(--viewport-below-app-bar)',
                        overflowX: 'hidden',
                        overflowY: 'auto',
                    }}
                >
                    <Outlet />
                </Stack>
            </Stack>
        </>
    )
}
